var _a;
import React from 'react';
import styled from 'styled-components';
const svgSprite = (_a = require('./sprite.svg')) === null || _a === void 0 ? void 0 : _a.default;
export const IconWrapper = styled.div `
  svg {
    vertical-align: middle;
  }
  .svg_icon-download-folder_2 {
    width: 16px;
    height: 14px;
  }
  .svg_icon-file {
    width: 13px;
    height: 16px;
  }
  .svg_icon-download-folder {
    width: 20px;
    height: 18px;
  }
  .svg_icon-down,
  .svg_icon-print,
  .svg_icon-up,
  .svg_icon-zoom-in,
  .svg_icon-zoom-out {
    width: 20px;
    height: 20px;
  }
  .svg_icon-multiply {
    width: 10px;
    height: 10px;
  }
  .svg_icon-success {
    width: 15px;
    height: 15px;
  }
`;
const Icon = ({ name, className }) => (React.createElement(IconWrapper, null,
    React.createElement("svg", { className: `svg_${name} ${className || ''}` },
        React.createElement("use", { xlinkHref: `${svgSprite}#${name}` }))));
Icon.defaultProps = {
    className: '',
};
export default Icon;
